"use strict";

exports.__esModule = true;
exports.default = {
  EMPTY_CALENDAR: 0,
  EMPTY_FILTER: 1,
  NO_VACATIONS: 2,
  NO_USERS: 3
};
module.exports = exports["default"];